module.exports = __webpack_public_path__ + "img/O2S.0e10fbd6.jpg";